'use client';

import { useEffect, useState } from 'react';
import { StnVideo } from '@/app_components/common/StnVideo';
import { useStickyFooter } from '@/app_lib/providers/StickyFooterProvider';
import type { AdTag } from '@/app_lib/types/Article';

export interface ArticleVideoProps {
  dataCy?: string;
  videoId: string;
  adTags?: AdTag[];
}

export const ArticleVideo = ({ videoId, adTags, dataCy = '' }: ArticleVideoProps) => {
  const [paywallHeight, setPaywallHeight] = useState(0);

  const { renderStickyFooter } = useStickyFooter();

  useEffect(() => {
    const paywallResizeObserver = new ResizeObserver((entries) => {
      setPaywallHeight(entries[0].contentRect.height);
    });

    const paywallElement = document.querySelector('.paywallax-ii-selector');
    if (paywallElement) {
      paywallResizeObserver.observe(paywallElement);
    }

    return () => paywallResizeObserver.disconnect();
  }, []);

  const stickyFooterRendered = paywallHeight === 0 && renderStickyFooter;

  return (
    <StnVideo
      adTags={adTags?.map((tag) => tag.node.name)}
      dataCy={dataCy}
      float={!stickyFooterRendered}
      floatVerticalTranslate={paywallHeight}
      videoId={videoId}
    />
  );
};
